export default __webpack_public_path__ + "img/apple-icon-57x57.png";